export default function currency (value, currency = '€') {
    return `${value} ${currency}`;
};
